import { useState } from "react";

export const useExternalApiRegistryFormState = () => {
  const [formData, setFormData] = useState({
    name: "",
    code: "",
    description: "",
    iRegistryId: null, // { label, value }
    gProductId: null, // { label, value }
    apiStatusId: null, // { label, value }
    isActive: true,

    nameStatus: "unchecked",
    codeStatus: "unchecked",
    iRegistryIdStatus: "unchecked",
    descriptionStatus: "unchecked",
    gProductIdStatus: "unchecked",
    apiStatusIdStatus: "unchecked",
  });

  const handleChange = (event, selectEvent) => {
    let state = { ...formData };

    /* =====================
       SELECT HANDLING
    ====================== */
    if (!event?.target && selectEvent) {
      state[selectEvent.name] = event;
      state[selectEvent.name + "Status"] = event?.value
        ? "success"
        : "unchecked";

      setFormData(state);
      return;
    }

    /* =====================
       INPUT HANDLING
    ====================== */
    const { name, value, type, checked } = event.target;

    switch (name) {
      case "name": {
        state.nameStatus =
          value.trim().length >= 2 ? "success" : value ? "error" : "unchecked";
        break;
      }

      case "code": {
        const regex = /^[A-Za-z]{2,10}$/;
        state.codeStatus = regex.test(value)
          ? "success"
          : value
          ? "error"
          : "unchecked";
        break;
      }

      case "description": {
        state.descriptionStatus =
          value.trim().length >= 5 ? "success" : value ? "error" : "unchecked";
        break;
      }

      default:
        break;
    }

    state[name] = type === "checkbox" ? checked : value;
    setFormData(state);
  };

  const checkAllFields = () =>
    formData.nameStatus === "success" &&
    formData.codeStatus === "success" &&
    formData.descriptionStatus === "success" &&
    formData.gProductIdStatus === "success" &&
    formData.apiStatusIdStatus === "success";

  return {
    formData,
    setFormData,
    handleChange,
    checkAllFields,
  };
};
